import React from 'react';
import { useSnackbar } from 'notistack';
import { SelectField } from 'components/Common/CustomFormikFields/SelectField';
import { Field } from 'formik';
import { handleReviewTicketNotification } from 'utils/NotificationsFuncs';

interface ICaseShare {
  userOpts: any;
  curUser: any;
  submitForm: any;
  setShareOpen: any;
  values: any;
  setFieldValue: any;
  date: string;
  caseId: string;
}

const CaseShareModal: React.FC<ICaseShare> = ({
  setShareOpen,
  userOpts,
  curUser,
  submitForm,
  values,
  setFieldValue,
  caseId,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const sendEmailToSharedUsers = async (caseData: any) => {
    const ids: any = [];
    if (caseData.sharedWith.length === 0) {
      return;
    }
    if (!curUser.basics) {
      enqueueSnackbar('Invalid credentials', { variant: 'error' });
    } else {
      // populate array with shared user(s)
      ids.push(caseData.sharedWith);
      ids[0]?.forEach(async (user: string) => {
        // IN APP NOTIFICATION
        handleReviewTicketNotification(caseData, curUser, user, caseId);
      });
    }
  };
  const shareOptions = [{ label: 'Select All', value: '__all__' }, ...(userOpts ?? [])];

  return (
    <div className="case-share-modal-container">
      <div className="case-share-modal-header">
        <div className="case-share-modal-header-content">
          <div className="case-share-content-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M10.21 14.75C10.303 14.8437 10.4136 14.9181 10.5354 14.9689C10.6573 15.0197 10.788 15.0458 10.92 15.0458C11.052 15.0458 11.1827 15.0197 11.3046 14.9689C11.4264 14.9181 11.537 14.8437 11.63 14.75L15.71 10.67C15.8983 10.4817 16.0041 10.2263 16.0041 9.96C16.0041 9.6937 15.8983 9.4383 15.71 9.25C15.5217 9.0617 15.2663 8.95591 15 8.95591C14.7337 8.95591 14.4783 9.0617 14.29 9.25L10.92 12.63L9.71 11.41C9.5217 11.2217 9.2663 11.1159 9 11.1159C8.7337 11.1159 8.4783 11.2217 8.29 11.41C8.1017 11.5983 7.99591 11.8537 7.99591 12.12C7.99591 12.3863 8.1017 12.6417 8.29 12.83L10.21 14.75ZM21 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM20 20H4V4H20V20Z"
                fill="white"
              />
            </svg>
          </div>
          <div className="case-share-content-text-group">
            <div className="case-share-content-primary-text">Share</div>
            <div className="case-share-content-secondary-text">
              Share and manage who can see this saved work.
            </div>
          </div>
        </div>
        <div className="case-share-modal-header-close-btn" onClick={() => setShareOpen(false)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="#85888E"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="case-share-modal-header-spacer"></div>
        <div className="case-share-modal-header-divider"></div>
      </div>
      <div className="case-share-modal-select-container">
        <div className="case-share-modal-select-form">
          <div className="case-share-form-inner">
            <div className="case-share-form-input-container">
              <div className="case-share-input-label-group">
                <div className="case-share-label-text">Add Users</div>
                <Field
                  name="sharedWith"
                  isMulti={true}
                  component={SelectField}
                  options={shareOptions}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="case-share-modal-actions-container">
        <div className="case-share-actions-btn-group">
          <div className="case-cancel-btn" onClick={() => setShareOpen(false)}>
            <div className="remove-user-btn-text">Cancel</div>
          </div>
          <div
            className="case-share-btn"
            onClick={() => {
              if (values.status !== 'complete') {
                if (values.sharedWith.length === 0) {
                  setFieldValue('status', 'draft');
                } else {
                  setFieldValue('status', 'pending');
                }
              }
              submitForm().then(() => sendEmailToSharedUsers(values));
              setShareOpen(false);
            }}
          >
            <div className="remove-user-btn-text">Done</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseShareModal;
